import React from "react";
import { Modal } from "react-bootstrap";
import ReactDOM from "react-dom";

export const ModalComponent = ({ show, setShow, title, children, size }) => {
  if (!show) return null;

  return ReactDOM.createPortal(
    <Modal
      show={show}
      onHide={() => setShow(false)}
      size={size || "sm"}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="h6 fw-bold">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>,
    document.getElementById("modal")
  );
};
